/**
 * A big number that shrinks to fit its card instead of being cut off
 * (Gordon 2026-11-03: "SEK 2…" — "make the numbers adapt in size so we can see
 * them"). The card around it needs `[container-type:inline-size]`; the size
 * follows the card's width and the number of characters, up to `max`.
 */

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function FitNumber({ children, className, max = "1.5rem" }: { children: ReactNode; className?: string; max?: string }) {
  const len = Math.max(4, String(children ?? "").length);
  return (
    <span
      className={cn("block min-w-0 overflow-hidden whitespace-nowrap font-bold leading-tight tabular-nums text-foreground", className)}
      style={{ fontSize: `min(${max}, ${(158 / len).toFixed(1)}cqw)` }}
    >
      {children}
    </span>
  );
}
